import React, { Component } from "react";
import Sidebar from "./components/Sidebar"
import ExternalLink from "components/ExternalLink";

import TermsAndConditionsContent from "./components/TermsAndConditionsContent";

class ProductTermsAndConditions extends Component {
    render() {
        return (
            <main className={"dashboard content-page " + this.props.type}>
                <Sidebar />
                <div className="content">
                <TermsAndConditionsContent />
                </div>
            </main>
        )
    }
}

export default ProductTermsAndConditions;